import { useEffect, useState } from 'react';
import { makeBEM } from '../global/utils';
import { LABELS } from '../global/constants';
import Icon from '../atoms/Icon';

function BudgetCategoryFilter({ 
                            moduleName='budget-category-filter',
                            categories=[],
                            filterFn,
                            clearFn,
                            disabled=false
 }) {

    const [catOptions, setCatOptions] = useState([]);
    const [ activeCat, setActiveCat ] = useState( {id: 0});
    const [ catSelected, setCatSelected ] = useState(false);
    const catSelectClass = `select select--skinny ${makeBEM(moduleName, 'category-select')}`;

    useEffect(() => {
        if ( categories ) {
			buildCategoryOptions();
		}
    }, [categories]);


    const buildCategoryOptions = () => {
		const catMap = new Map();
		
		catMap.set(-1, LABELS.categoryFilter);

		categories.forEach((cat) => {
			catMap.set(cat.id, cat.name)
		});

		setCatOptions(catMap);
	}

    const handleCatChange = (e) => {
        const { name, value } = e.target;

        const parsedValue = parseInt(value);
        const activeCatId = isNaN(parsedValue) ? value : parsedValue;

        setActiveCat( {id: activeCatId } );
        setCatSelected( true );

        if ( filterFn ) {
            filterFn( {id : activeCatId} );
        }
    }

    const clearBtnClick = (e) => {
        setActiveCat( { id: 0 });
        setCatSelected( false );
        
        if ( clearFn ) {
            clearFn();
        }
    }

    return (
        <div className={ moduleName } >
            <div className={ makeBEM( moduleName, 'inputs-wrapper' ) }>
                <select
                    className={ catSelectClass }
                    id="category_id"
                    name="category_id"
                    onChange = { handleCatChange }
                    value={ activeCat.id }
                    disabled={disabled}
                >

                    {
                        Array.from(catOptions.values()).map((value, index) => (
                            <option key={index} value={ parseInt(index) } disabled={ index === 0 }>
                                {value}
                            </option>
                        ))
                    }
                </select>

                <button
                    className={ `btn btn--icon btn--molding ${makeBEM(moduleName, 'clear-btn')}` }
                    onClick={clearBtnClick}
                    disabled={ !catSelected }
                    type="button"
                >
                    <Icon name="close"/>
                </button>
            </div>
        </div>
    )
 }

 export default BudgetCategoryFilter;